import { render } from "./device-details-data.vue?vue&type=template&id=55f8c78e&scoped=true&ts=true"
import script from "./device-details-data.ts?vue&type=script&lang=ts"
export * from "./device-details-data.ts?vue&type=script&lang=ts"

import "./device-details-data.scss?vue&type=style&index=0&id=55f8c78e&lang=scss&scoped=true"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f8c78e"]])

export default __exports__